<app-data-grid
  [viewId]="viewId"
  [title]="title"
  [icon]="icon"
  gridClassName="export-schedules-grid"
  [columnDefs]="columnDefs"
  [fetchRows]="fetchRows"
  [refreshOnCompanyObjectsToggle]="true"
></app-data-grid>
